import { extendObservable } from 'mobx';

class NetworkModel {
    constructor(session) {
        this._session = session;

        extendObservable(this, {
            webproto: '',
            ifname: '',
            ip6assign: '',
            ipaddr: '',
            netmask: '',
            proto: '',
            gateway: '',
            dns: '',
            alternativeDNS: '',
            dhcpname: '',
            sonicip: '',
            sonicipvolume: '',
            errorNetwork: true
        });
    }

    clearState = '';

    async load() {
        console.log('NetworkModel: loading...');

        try {
            const settings = await this._session.rpc('call', [
                '',
                'network',
                'status',
                {}
            ]);
            const settingsSonicIP = await this._session.rpc('call', [
                '',
                'uci',
                'get',
                {
                    config: 'network',
                    section: 'sonic_ip'
                }
            ]);

            const settingsSonicIPVolume = await this._session.rpc('call', [
                '',
                'uci',
                'get',
                {
                    config: 'network',
                    section: 'sonic_ip',
                    option: 'volume'
                }
            ]);
            console.log(
                'get settingsSonicIPVolume:' +
                    JSON.stringify(settingsSonicIPVolume)
            );

            let IPVolume = '0%';

            if (settingsSonicIPVolume[1].hasOwnProperty('value')) {
                IPVolume = settingsSonicIPVolume[1].value;
            }

            if (IPVolume !== undefined) {
                if (!IPVolume.endsWith('%')) {
                    IPVolume = IPVolume + '%';
                }
            }

            const settingsdhcp = await this._session.rpc('call', [
                '',
                'uci',
                'get',
                {
                    config: 'network',
                    section: 'eth0',
                    option: 'dhcpname'
                }
            ]);
            console.log('get settingsdhcp:' + JSON.stringify(settingsdhcp));
            let getdhcpname = 'instreamer-ice';
            if (settingsdhcp[1].hasOwnProperty('value')) {
                getdhcpname = settingsdhcp[1].value;
            } else {
                console.error('network.eth0.dhcpname not found in UCI');
            }
            console.log('getdhcpname:' + getdhcpname);

            const settingsWebProto = await this._session.rpc('call', [
                '',
                'uci',
                'get',
                {
                    config: 'httpd',
                    section: 'webserver',
                    option: 'protocol'
                }
            ]);

            console.log('get settingshttp:' + JSON.stringify(settingsWebProto));
            let webprotocol = settingsWebProto[1].value;

            let gate,
                dnsServer,
                dnsAlternative,
                sonicIpSetting,
                ipaddress,
                netm,
                sonicIPVolumeSetting;

            if (settings[1]['route']) {
                for (let i = 0; i < settings[1]['route'].length; i++) {
                    if (settings[1]['route'][i].target === '0.0.0.0') {
                        gate = settings[1]['route'][i].nexthop;
                    }
                }
            } else {
                gate = '';
            }

            if (settings[1]['dns-server']) {
                if (settings[1]['dns-server'].length === 1) {
                    dnsServer = settings[1]['dns-server'][0];
                    dnsAlternative = '';
                } else if (settings[1]['dns-server'].length > 1) {
                    dnsServer = settings[1]['dns-server'][0];
                    dnsAlternative = settings[1]['dns-server'][1];
                } else {
                    dnsServer = '';
                    dnsAlternative = '';
                }
            } else {
                dnsServer = '';
                dnsAlternative = '';
            }

            if (
                settingsSonicIP[1]['values'] &&
                settingsSonicIP[1]['values'].enabled
            ) {
                sonicIpSetting = settingsSonicIP[1]['values'].enabled;
                sonicIPVolumeSetting = IPVolume;
            } else {
                sonicIpSetting = false;
                sonicIPVolumeSetting = 0;
            }

            if (settings[1]['ipv4-address']) {
                ipaddress = settings[1]['ipv4-address'][0];
                netm = getNetmask(settings[1]['ipv4-address'][1]);
            } else {
                ipaddress = '';
                netm = '';
            }

            const settingobj = {
                webproto: webprotocol,
                ipaddr: ipaddress,
                gateway: gate,
                netmask: netm,
                proto: settings[1].proto,
                dns: dnsServer,
                alternativeDNS: dnsAlternative,
                dhcpname: getdhcpname,
                sonicip: sonicIpSetting,
                sonicipvolume: sonicIPVolumeSetting,
                errorNetwork: false
            };

            this.clearState = settingobj;

            Object.assign(this, settingobj);
        } catch (err) {
            console.error('NetworkModel: ' + err);
        }

        console.log('NetworkModel: loaded');
    }

    clear() {
        Object.assign(this, this.clearState);
    }

    validate(name) {
        console.log('validade:' + JSON.stringify(name));
        switch (name) {
            case 'netmask':
                if (!isNaN(netmaskToCIDR(this.netmask))) {
                    return true;
                } else {
                    return 'The netmask is invalid. Check if your netmask is set according to the rules';
                }

            case 'dhcpname':
                if (this.dhcpname === '') {
                    return 'DHCP name cannot be empty';
                } else {
                    return true;
                }
            case 'ipaddr':
                if (
                    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                        this.ipaddr
                    )
                ) {
                    return true;
                } else {
                    return 'The ip address consists of four decimal numbers, each ranging from 0 to 255, separated by dots';
                }
            case 'gateway':
                if (
                    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                        this.gateway
                    ) &&
                    this.gateway !== this.ipaddr &&
                    this.gateway !== this.netmask
                ) {
                    if (
                        inSubNet(
                            this.ipaddr,
                            this.gateway,
                            netmaskToCIDR(this.netmask)
                        )
                    ) {
                        return true;
                    } else {
                        return 'The gateway must be in the same subnet of the IP Address';
                    }
                } else {
                    return "The gateway consists of four decimal numbers, each ranging from 0 to 255, separated by dots. It can't be the same as ip address or netmask.";
                }
            case 'dns':
                if (
                    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                        this.dns
                    ) &&
                    this.dns !== this.alternativeDNS
                ) {
                    return true;
                } else {
                    return "The DNS consists of four decimal numbers, each ranging from 0 to 255, separated by dots. It can't be the same as alternative DNS.";
                }
            case 'alternativeDNS':
                if (
                    (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                        this.alternativeDNS
                    ) &&
                        this.alternativeDNS !== this.dns) ||
                    this.alternativeDNS === ''
                ) {
                    return true;
                } else {
                    return "The Alternative DNS consists of four decimal numbers, each ranging from 0 to 255, separated by dots. It can't be the same as DNS.";
                }
            case 'sonicipvolume':
                let valuevolume = this.sonicipvolume.replace('%', '');
                valuevolume = Number(valuevolume);

                if (this.sonicipvolume === '') {
                    return 'Sonic IP volume name cannot be empty';
                }

                if (!isFinite(valuevolume)) {
                    return 'The SonicIP® Volume must be a number followed by %';
                } else {
                    if (
                        valuevolume >= 0 &&
                        valuevolume <= 100 &&
                        isNaturalNumber(valuevolume)
                    ) {
                        return true;
                    } else {
                        return 'The SonicIP® Volume must be a natural value between 0% and 100%';
                    }
                }
            default:
                console.error('validate: missing rule for=' + name);
                break;
        }
    }
}

function isNaturalNumber(str) {
    var pattern = /^(0|([1-9]\d*))$/;
    return pattern.test(str);
}

function inSubNet(ip, gateway, netmask) {
    if (
        (IPnumber(ip) & IPmask(netmask)) ===
        (IPnumber(gateway) & IPmask(netmask))
    ) {
        return true;
    } else {
        return false;
    }
}

function IPnumber(IPaddress) {
    let ip = IPaddress.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/);
    if (ip) {
        return (+ip[1] << 24) + (+ip[2] << 16) + (+ip[3] << 8) + +ip[4];
    }
    return null;
}

function IPmask(maskSize) {
    return -1 << (32 - maskSize);
}

function pow2(n) {
    if (n === 0) return 1;
    return Math.abs(2 << (n - 1));
}

function intToOctets(input, limit) {
    let octets = [];
    for (let i = 0; i <= limit; i++) {
        let divider = pow2((limit - i) * 8);
        let result = 0;
        if (input >= divider) {
            result = input / divider;
        }
        octets[i] = Math.trunc(result);
        input = input % pow2((limit - i) * 8);
    }
    return octets;
}

function octetsToString(octets) {
    return `${octets[0]}.${octets[1]}.${octets[2]}.${octets[3]}`;
}

function getNetmask(bitmask) {
    let result = 0;
    let count = bitmask;
    while (count > 0) {
        result += pow2(32 - count);
        count--;
    }

    return octetsToString(intToOctets(result, 3));
}

function netmaskToCIDR(mask) {
    let bytes = mask
        .split('.')
        .map(i => parseInt(i, 10))
        .filter(v => !isNaN(v));

    if (bytes.length !== 4) {
        return NaN;
    }

    let binMask = bytes.reduce((a, v) => (a << 8) | v, 0);
    let i = 0;
    for (i = 0; i < 32; i++) {
        if ((binMask & (1 << 31)) === 0) {
            break;
        }
        binMask <<= 1;
    }

    return binMask === 0 ? i : NaN;
}

export default NetworkModel;



// WEBPACK FOOTER //
// ./src/models/NetworkModel.js